module Meevo.Plugins.ClientPoint {

    class ReasonModalController {

        static $inject = ['$mdDialog', 'adjustmentNote'];

        constructor(
            protected $mdDialog: angular.material.IDialogService,
            protected adjustmentNote: string) { }

        cancel = () => {
            this.$mdDialog.hide();
        };
    }

    angular.module('meevo.plugins.clientPoint')
        .controller('meevo.plugins.clientPoint.ReasonModalController', ReasonModalController);
}